<script>
import UserDetailContactsTab from '@/components/user/tabs/UserDetailContactsTab.vue';
import UserDetailReferralsTab from '@/components/user/tabs/UserDetailReferralsTab.vue';
import UserDetailPaymentsTab from '@/components/user/tabs/UserDetailPaymentsTab.vue';
import UserDetailHistoryTab from '@/components/user/tabs/UserDetailHistoryTab.vue';
import CommonSection from '@/components/CommonSection.vue';
import UserDetailCommonTab from '@/components/user/tabs/UserDetailCommonTab.vue';
import UserDetailSummaryTab from '@/components/user/tabs/UserDetailSummaryTab.vue';
import BaseTabs2 from '@/components/BaseTabs2.vue';
import BaseButton from '@/components/BaseButton.vue';

export default {
  name: 'UserDetailLayout',
  components: {
    CommonSection,
    UserDetailCommonTab,
    UserDetailSummaryTab,
    UserDetailContactsTab,
    UserDetailReferralsTab,
    UserDetailPaymentsTab,
    UserDetailHistoryTab,
    BaseTabs2,
    BaseButton,
  },
  props: {
    user: Object,
    additionalInfo: Object,
    isAdmin: Boolean,
    tab: String,
  },
  data() {
    return {
      item: null,
      isEditMode: false,
      keysToUpdate: new Set(),
    };
  },
  watch: {
    user: {
      handler(value) {
        this.item = { ...value };
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    userName() {
      const { name, surname, email } = this.user;
      return (name && surname) ? `${name} ${surname}` : email;
    },

    tabs() {
      return [
        { name: 'common',       label: 'Общая информация'       }, // eslint-disable-line
        { name: 'summary',      label: 'Сводная информация'     }, // eslint-disable-line
        { name: 'contacts',     label: 'Контакты'               }, // eslint-disable-line
        { name: 'referrals',    label: 'Партнёрская программа'  }, // eslint-disable-line
        { name: 'payments',     label: 'Платежи'                }, // eslint-disable-line
        { name: 'history',      label: 'История'                }, // eslint-disable-line
      ];
    },
  },
  methods: {
    onChange(event) {
      const key = Object.keys(event)[0];
      this.keysToUpdate.add(key);

      this.item = { ...this.item, ...event };
    },

    emit() {
      const dataToUpdate = {};

      this.keysToUpdate.forEach(key => {
        dataToUpdate[key] = this.item[key];
      });

      this.$emit('update', dataToUpdate);
      this.isEditMode = false;
      this.keysToUpdate = new Set();
    },
  },
};
</script>

<template lang="pug">
  CommonSection(:title="userName")
    .b-user-detail-layout
      ._header
        BaseTabs2(:items="tabs" :value="tab" @input="$emit('changeTab', $event)")
        ._header-buttons
          BaseButton._header-button(v-if="tab === 'common' && !isEditMode" @click="isEditMode = true" blue round md) Редактировать
          BaseButton._header-button(v-if="tab === 'common' && isEditMode" @click="emit" blue round md) Сохранить
          BaseButton._header-button(v-if="tab === 'common' && isEditMode" @click="isEditMode = false" grey round md) Отменить
      UserDetailCommonTab(
        v-if="tab === 'common'"
        :item="item"
        :isEditMode="isEditMode"
        :isAdmin="isAdmin"
        @change="onChange"
        @onAvatarChanged="$emit('onAvatarChanged', $event)"
        @confirm="$emit('update', $event)"
        @goToTariffs="$emit('goToTariffs', $event)"
        @showPopup="$emit('showPopup', $event)"
        @deleteAccount="$emit('deleteAccount', $event)"
        )
      UserDetailSummaryTab(v-if="tab === 'summary'" :user="user" :statistics="additionalInfo.userStatistics")
      UserDetailContactsTab(v-if="tab === 'contacts'" :contacts="additionalInfo.contacts" :user="user" @deleteContact="$emit('deleteContact', $event)")
      UserDetailReferralsTab(v-if="tab === 'referrals'" :referrals="additionalInfo.referrals" :payouts="additionalInfo.payouts" :user="user")
      UserDetailPaymentsTab(v-if="tab === 'payments'" :user="user")
      UserDetailHistoryTab(v-if="tab === 'history'")
</template>

<style scoped lang="scss">
.user-detail-layout {
  &__header {
    padding-bottom: 50px;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  }

  &__header-buttons {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 15px;
  }

  &__header-button {
    text-decoration: underline dashed;
    text-decoration-thickness: 1px;
    text-underline-offset: 5px;
  }
}
</style>
